import { FacetValueTags } from "./FacetValueTags";
import { FacetGroupSelect } from "./FacetGroupSelect";
import { FilterTitles } from "./FilterTitles";
import { Filter } from "./Filter";
import { ShadowFacetTracking } from "./ShadowFacetTracking";
import { OcFilterAccordion } from "./OcFilterAccordion";
import { OcFilterAccordions } from "./OcFilterAccordions";

export function registerFilterStuff() {
  OcFilterAccordion.register();
  FacetGroupSelect.register();
  FacetValueTags.register();
  OcFilterAccordions.register();
  FilterTitles.register();
  Filter.register();
  ShadowFacetTracking.register();
}
